import React, { useState, useEffect } from "react";
import {Container, Row, Col} from "react-bootstrap";
import Stats from "./Stats";
import { stats } from "../data/relics";

const StatComparison = (props) => {

    const displayDerivedStat = (prefix, suffix, leftStat, rightStat, bold) => {
        let symbol, color;
        let diff = leftStat - rightStat;
        let fontWeight = bold ? 'bold': 'normal'

        if (leftStat >= rightStat)
        {
            symbol = '+';
            color = 'green';
        }
        else
        {
            symbol = '';
            color = 'red';
        }

        return (
            <Row key={prefix}>
                <Col className="p-0 stats" style={{textAlign: 'right', fontWeight: fontWeight}}>
                    { prefix + ' ' + leftStat + ' ' + suffix }
                </Col>
                <Col xs={'auto'} className="p-0 stats" style={{width: '45px', textAlign: 'center', fontWeight: fontWeight, color: color}}>
                    { symbol + diff}
                    
                </Col>
                <Col className="p-0 stats" style={{textAlign: 'left', fontWeight: fontWeight}}>
                    { prefix + ' ' + rightStat + ' ' + suffix }
                    
                </Col>
            </Row>  
        )
    };

    const displayCombinedStats = () => {
        let ninja1Keys = Object.keys(props.ninja1Stats);
        let ninja2Keys = Object.keys(props.ninja2Stats);
        if (!ninja1Keys.length && !ninja2Keys.length)
        {
            return;
        }

        let ninja1Stats = JSON.parse(JSON.stringify(props.ninja1Stats));
        let ninja2Stats = JSON.parse(JSON.stringify(props.ninja2Stats));
        addMissingStats(ninja1Stats, ninja2Stats);
        addMissingStats(ninja2Stats, ninja1Stats);
        ninja1Stats = reorderKeys(ninja1Stats);
        ninja2Stats = reorderKeys(ninja2Stats);

        return (
            Object.keys(ninja1Stats).map((key, index) => {
                let prefix = stats[key].prefix;
                let suffix = stats[key].suffix;
                return displayDerivedStat(prefix, suffix, ninja1Stats[key], ninja2Stats[key], false);
            })
        )

        let foo = 'bar';
    };

    const reorderKeys = (unordered) => {
        let ordered = Object.keys(unordered).sort().reduce(
            (obj, key) => {
                obj[key] = unordered[key];
                return obj;
            }, {} 
        );
        return ordered;
    };

    const addMissingStats = (left, right) => {
        let leftKeys = Object.keys(left);
        let rightKeys = Object.keys(right);
        let i, len, key;

        for (i = 0, len = leftKeys.length; i < len; i++)
        {
            key = leftKeys[i];
            if (!right.hasOwnProperty(key))
            {
                right[key] = 0;
            }
        }
    };

    return (
        <Container fluid>
            { displayDerivedStat('Total Shuriken ATK', '', props.ninja1Shuriken, props.ninja2Shuriken, true) }
            { displayDerivedStat('Total Weapon ATK', '', props.ninja1Weapon, props.ninja2Weapon, true) }
            { displayDerivedStat('Total Ninjutsu ATK', '', props.ninja1Ninjutsu, props.ninja2Ninjutsu, true) }
            <Row><Col className="stats">&nbsp;</Col></Row>
            { displayCombinedStats() }
        </Container>
    );
};

export default StatComparison;